import { combineReducers } from 'redux';
import searchReducer from './searchReducer';
import resultsReducer from './resultsReducer';
import * as types from '../actions/actionTypes';
import stepperReducer from './stepperReducer';
import autoCompleteReducer from './autoCompleteReducer';
import assetsReducer from './assetsReducer';
import tagReducer from './tagReducer';
import uiReducer from './uiReducer';
import productsReducer from './productsReducer';
import submittedAssetsReducer from './submittedAssetsReducer';
import manageAssetReducer from './manageAssetReducer';
import manageProductReducer from './manageProductReducer';
import resultsSearchTermReducer from './resultsViewSearchTermReducer';
import userReducer from './userReducer';
import createJiraTicketReducer from './createJiraTicketReducer';
import createAssetReducer from './createAssetReducer';
import missingProductsReducer from './missingProductsReducer';

//combining all app reducers using redux combine reducers function
const appReducer = combineReducers({
	search: searchReducer,
	results: resultsReducer,
	stepper: stepperReducer,
	autoComplete: autoCompleteReducer,
	assets: assetsReducer,
	tags: tagReducer,
	ui: uiReducer,
	productssearchoptions: productsReducer,
	submittedAssets: submittedAssetsReducer,
	manageAssetDetails: manageAssetReducer,
	manageProductDetails: manageProductReducer,
	resultsSearchTerm: resultsSearchTermReducer,
	user: userReducer,
	shouldCreateJiraTicket: createJiraTicketReducer,
	isCSVUploadViewLoaded: createAssetReducer,
	missingProducts: missingProductsReducer,
});
// Resetting data at root reducer level. to eliminate redundant logic at individual reducer level.
const rootReducer = (state, action) => {
	if (action.type === types.RESET_SEARCH_DATA) {
		state.search = undefined;
	}
	// Resetting assets data when create more 3d assets button is clicked after review and submit.
	if (action.type === types.RESET_ASSET_DATA) {
		state.assets = undefined;
		state.missingProducts = undefined;
	}
	// Resetting tags data when create more 3d assets button is clicked after review and submit.
	if (action.type === types.RESET_TAGS_DATA) {
		state.tags = undefined;
	}
	// Resetting Manage asset to initial state once asset has been delete from manage asset page.
	if (action.type === types.MANAGE_ASSET_DELETE_ASSET) {
		state.manageAssetDetails = undefined;
	}
	// Resetting Manage product to initial state once the product page has been left
	if (action.type === types.MANAGE_PRODUCT_RESET_STATE) {
		state.manageAssetDetails = undefined;
	}
	return appReducer(state, action);
};
export default rootReducer;
